<template>
  <div id="app">
   <keep-alive>
        <!-- 需要缓存的视图组件 --> 
        <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive>
      <!-- 不需要缓存的视图组件 -->
     <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  -webkit-overflow-scrolling: touch;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body, ol, ul, h1, h2, h3, h4, h5, h6, p, th, td, dl, dd, form, fieldset, legend, input, textarea, select, img{
    padding: 0;
    margin: 0;
}
body{
    font-family: 'PingFangSC-Medium','PingFangSC', Helvetica, Arial, sans-serif;
    position: relative;
}
html{
    overflow: hidden;
}
body,html,#app,.container{
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: #F2F4F7;




}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
.w1140{
    width: 1140px;
}
a{
    text-decoration: none;
}
.clearfix:after{
    content:".";
    display:block;
    height:0;
    clear:both;
    visibility:hidden;
}
.pr{
    position: relative;
}
.pa{
    position: absolute;
}
.pf{
    position: fixed;
}
.ma{
    margin: 0 auto;
}
.text_ellipsis{
    overflow: hidden;/*内容超出后隐藏*/
    text-overflow: ellipsis;/* 超出内容显示为省略号*/
    white-space: nowrap;/*文本不进行换行*/
}
.text_center{
  text-align: center;
}
.f14{
  font-size: 14px;
}
.f13{
  font-size: 13px;
}
.f16{
  font-size: 16px;
}
.f18{
  font-size: 18px;
}
/* 滚动条样式 */
.scrollbar-track {
    background: rgba(0, 0, 0, 0.05) !important;
}

.scrollbar-track-x {
    height: 8px !important;
}

.scrollbar-track-y {
    width: 8px !important;
}

.scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1) !important;
    border-radius: 3px !important;
    border: 1px solid #fff;
}
.react-data-scrollbar {
    position: relative;
    top: 0;
    left: 0;
    width: 8px;
    border: 1px solid #fff;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
}

::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}
::-webkit-scrollbar-corner {
    background: #000;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    height: 60px;
    border: 0;
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
  background: none;
}

::-webkit-scrollbar-corner {
  background: transparent;
}
.common-head{
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
}
.common-head i.arrow-back{
  display: inline-block;
  width: 30px;
  height: 30px;
  background: url(../src/assets/back.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 7px;
  left: 6px;
  bottom: 0;
  right: 13.5px;
}
.common-head p.head-title{
  font-size: 18px;
  color: #333333;
  font-weight: 600;
  margin: 0 auto;
}
.park-bt-border{
  width: 93%;
  height: 1px;
  background: #F3F3F3;
  margin: 0 auto;
}
.color_333{
  color: #333333;
}
.bold {
  font-weight: bold;
}
.mar_top_15 {
  margin-top: 10px;
}
.mar_top_12 {
  margin-top: 12px;
}
.color_666 {
  color: #666666;
}
.line_height_22{
  line-height: 22px;
}
.letter_space{
  letter-spacing: 1.5px;
}
.van-cell {
  color: #333333;
}
.van-icon-arrow:before {
  color: #cccccc;
}
.answer_content {
  padding: 0 14px 0 37px;
}
.van-cell {
  padding: 19px 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue